module.exports = __webpack_public_path__ + "media/images/lp_v6_class-556c4ee4b66d15cfc19870be6937a47d.webp";